export default "__VITE_ASSET__sqHABQuP__"